import * as React from "react";
import { Grid } from "semantic-ui-react";

import { VideoScriptsList } from "@/components/Lists/VideoScriptsList";
import { WhiteContainer } from "../../../../../styling/baseStyle";

import "./styles.scss";
import { URLS } from "../../../../../utils";

const PlayerVideoScriptsSectionFC: React.FC = () => {
  return (
    <WhiteContainer>
      <div className={"playerVideoScriptsList"}>
        <Grid.Row className={"menuBaseContainer"}>
          <Grid.Column>
            <VideoScriptsList redirectUrl={URLS.player.videoScript} />
          </Grid.Column>
        </Grid.Row>
      </div>
    </WhiteContainer>
  );
};

export const PlayerVideoScripts = PlayerVideoScriptsSectionFC;
